import React from 'react';
import { UserSearchInput } from 'components/Collaborators/Invite/UserSearchInput/UserSearchInput';
import { InfoMessage } from '../../components/InfoMessage';
import { useSelector } from 'hooks/utils';
import { LanguageType } from 'types/index';

const DICTIONARY = {
	[LanguageType.English]: {
		addCollaborators: 'Add collaborators',
		addCollaboratorsToProject: 'Add collaborators to this project',
		searchByNameOrEmail: 'Search by name or email',
		ousInvite:
			'HSE employees must order an account via BAT before they can be added to the project. Partners outside HSE (external) are invited to your project by sending an email to oushfpbregisterstott@ous-hf.no according to the procedure in the E-manual.',
		hseInvite:
			'Employees in HSE must order an account via BAT before they can be added to the project. Partners outside HSE (external) are invited to your project by adding their email address(es). External users will receive an email invitation with a link to register and then get access to the project.',
		generalInvite:
			'Collaborators are invited to your project by adding their email address(es). Collaborators without a Ledidi account will receive an email invitation with a link to register and then get access to the project.'
	},
	[LanguageType.Norwegian]: {
		addCollaborators: 'Legg til samarbeidspartnere',
		addCollaboratorsToProject: 'Legg til samarbeidspartnere i dette prosjektet',
		searchByNameOrEmail: 'Søk etter navn eller e-post',
		ousInvite:
			'Ansatte i HSØ må bestille konto via BAT før de kan legges til i prosjektet. Samarbeidspartnere utenfor HSØ (eksterne) inviteres til prosjektet ditt ved å sende mail til oushfpbregisterstott@ous-hf.no i henhold til prosedyre i E-håndboken.',
		hseInvite:
			'Ansatte i HSØ må bestille konto via BAT før de kan legges til i prosjektet. Samarbeidspartnere utenfor HSØ (eksterne) inviteres til prosjektet ditt ved å legge til e-postadressen(e) deres. Eksterne brukere vil få en e-postinvitasjon med link til å registrere seg og får deretter tilgang til prosjektet. ',
		generalInvite:
			'Samarbeidspartner inviteres til prosjektet ditt ved å legge til e-postadressen(e) deres. Samarbeidspartner som ikke har bruker vil få en e-postinvitasjon med link til å registrere seg og får deretter tilgang til prosjektet.'
	}
};

interface SelectUsersStepProps {
	newUsers: string[];
	setNewUsers: React.Dispatch<React.SetStateAction<string[]>>;
	excludeEmailAddresses: string[];
	inviteCollaboratorSearch: boolean;
	canInviteExternalUser?: boolean;
}

export const SelectUsersStep: React.FC<SelectUsersStepProps> = ({
	newUsers,
	setNewUsers,
	excludeEmailAddresses,
	inviteCollaboratorSearch,
	canInviteExternalUser = false
}) => {
	const language = useSelector(state => state.ui.i18n.language);
	const dictionary = DICTIONARY[language];

	// Determine invite message based on feature flag
	let inviteMessage = dictionary.generalInvite;
	if (inviteCollaboratorSearch) {
		inviteMessage = dictionary.hseInvite;
	}

	return (
		<div>
			<div className="mb-8">
				<h2 className="text-2xl font-bold text-gray-800 mb-4">
					{dictionary.addCollaborators}
				</h2>

				<UserSearchInput
					label={dictionary.addCollaboratorsToProject}
					placeholder={dictionary.searchByNameOrEmail}
					users={newUsers}
					setUsers={setNewUsers}
					excludeEmailAddresses={excludeEmailAddresses}
					canInviteExternalUser={canInviteExternalUser}
					inviteCollaboratorSearch={inviteCollaboratorSearch}
				/>
			</div>

			<InfoMessage message={inviteMessage} />
		</div>
	);
};
